import { AvailabilityData } from '~hooks';

export const modifiers = (
    renderAvailabilityCalendar: boolean,
    availabilityData: AvailabilityData,
    displayBlockDatesFeature: boolean
) => ({
    datePickerModifiers: renderAvailabilityCalendar
        ? {
              availabilityCheckins: availabilityData.availabilityCheckinDates,
              availabilityCheckouts: availabilityData.availabilityCheckoutDates,
              checkoutDates: availabilityData.checkoutDates,
              checkinDates: availabilityData.checkinDates,
              blockedDates: displayBlockDatesFeature
                  ? availabilityData.blockedDates
                  : []
          }
        : undefined
});
